module.exports = __webpack_public_path__ + "MinionPro-Regular.46b0e962000e5fab2679.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/MinionPro-Regular/MinionPro-Regular.ttf
// module id = ../../../../../src/assets/fonts/MinionPro-Regular/MinionPro-Regular.ttf
// module chunks = styles